module.exports = __webpack_public_path__ + "img/22.66b0a145.jpg";